/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Streamerreport_Meta_Description1Inputs */

const ja_playdata_streamerreport_meta_description1 = /** @type {(inputs: Playdata_Streamerreport_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注目のストリーマーと、そのストリーマーが牽引するゲームの人気度を把握できます。`)
};

const en_playdata_streamerreport_meta_description1 = /** @type {(inputs: Playdata_Streamerreport_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover and analyse popular Japanese streamers and the games they drive.`)
};

/**
* | output |
* | --- |
* | "Discover and analyse popular Japanese streamers and the games they drive." |
*
* @param {Playdata_Streamerreport_Meta_Description1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_streamerreport_meta_description1 = /** @type {((inputs?: Playdata_Streamerreport_Meta_Description1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Streamerreport_Meta_Description1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_streamerreport_meta_description1(inputs)
	return en_playdata_streamerreport_meta_description1(inputs)
});
export { playdata_streamerreport_meta_description1 as "playdata_streamerReport_meta_description" }